import { createEvent, createStore, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import { gatewayBlockChanged } from '../blockGateway'
import { GatewayHistoryResponse, GatewayHistorySummary } from '../types'
import { HistoryListLoadPayload } from './types'
import { toHistoryRequest } from './utils'

export const historyLoad = createEvent<HistoryListLoadPayload>()

export const getGatewayHistoryFx = fx<void, GatewayHistoryResponse>({
  method: 'GET',
})

export const $historyItems = createStore<GatewayHistorySummary[]>([]).on(
  getGatewayHistoryFx.doneData,
  (_, response) => response.body.items,
)

export const $historyTotal = createStore<number>(0).on(
  getGatewayHistoryFx.doneData,
  (_, response) => response.body.total,
)

// The refetch has no access to the component's filters, so the last request
// is kept here.
const $lastHistoryRequest = createStore<HistoryListLoadPayload | null>(null).on(
  historyLoad,
  (_, payload) => payload,
)

sample({
  clock: historyLoad,
  filter: ({ clientId }) => Boolean(clientId),
  fn: toHistoryRequest,
  target: getGatewayHistoryFx,
})

sample({
  clock: gatewayBlockChanged,
  source: $lastHistoryRequest,
  filter: (request): request is HistoryListLoadPayload =>
    Boolean(request?.clientId),
  fn: toHistoryRequest,
  target: getGatewayHistoryFx,
})

sample({
  clock: getGatewayHistoryFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
